/**
 * Description: Value formatting utilities for CoconutJS components
 * Purpose: Shared formatting functions for displaying values in UI components
 * Author: Nuvemx
 * Created: 2026
 */

/**
 * Format a value for display in HTML
 * @param {*} value - The value to format
 * @returns {string} HTML string representation of the value
 */
export function formatValue(value) {
    if (value === null) return '<em>null</em>';
    if (value === undefined) return '<em>undefined</em>';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'object') return JSON.stringify(value);
    if (typeof value === 'string' && value.length > 50) {
        return value.substring(0, 50) + '...';
    }
    return String(value);
}

/**
 * Format a value for use in an input field
 * @param {*} value - The value to format
 * @param {string} inputType - The input type (text, number, datetime-local, etc.)
 * @returns {string} String representation for input value attribute
 */
export function formatInputValue(value, inputType) {
    if (typeof value === 'object') return JSON.stringify(value);
    if (inputType === 'datetime-local' && typeof value === 'string') {
        return value.substring(0, 16);
    }
    return String(value);
}

/**
 * Format a key/name into a human-readable label
 * @param {string} key - The key to format (e.g., 'firstName', 'first_name')
 * @returns {string} Formatted label (e.g., 'First Name')
 */
export function formatLabel(key) {
    return key.replace(/([A-Z])/g, ' $1')
             .replace(/^./, str => str.toUpperCase())
             .replace(/_/g, ' ');
}

/**
 * Determine the appropriate input type based on a value
 * @param {*} value - The value to analyze
 * @returns {string} The suggested input type
 */
export function getInputType(value) {
    if (typeof value === 'number') return 'number';
    if (typeof value === 'boolean') return 'checkbox';
    if (typeof value === 'string' && value.includes('@')) return 'email';
    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/)) return 'datetime-local';
    return 'text';
}
